import React, { useEffect, useState, useRef } from "react";
import { motion, useViewportScroll, useTransform } from 'framer-motion';
import CSReviewImage1 from "../../images/Review-img-1.png";
import CSReviewImage2 from "../../images/Mobile.png";
import CSReviewImage3 from "../../images/Review-img-2.png";
import CSReviewImage4 from "../../images/Review-img-3.png";

import CSReviewIpadImage1 from "../../images/Review-ipad-img-1.jpeg";
import CSReviewIpadImage2 from "../../images/Review-ipad-img-2.jpeg";
import CSReviewIpadImage3 from "../../images/Review-ipad-img-3.jpeg";

export default function CsCustomerRating(props) {
  const [elementTop, setElementTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const { scrollY } = useViewportScroll();
  const ref = useRef();
  const easing = [0.42, 0, 0.58, 1];

  const setValues = () => setTimeout(() => {
    if (!ref.current) return;
    setElementTop(ref.current.offsetTop);
    setClientHeight(window.innerHeight);
  }, 1000);

  useEffect(() => {
    if (!ref.current) return;
    props.isLoaded && setValues();
    window.addEventListener('resize', setValues);
    document.addEventListener('load', setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  });
  const scale0 = useTransform(scrollY, [elementTop - clientHeight, elementTop - clientHeight / 2], [0, 1], easing);
  const mobileY = useTransform(scrollY, [elementTop - clientHeight * 1.2, elementTop - clientHeight * 0.5], [-200, 0], easing);
  const mobileOp = useTransform(scrollY, [elementTop - clientHeight * 1.2, elementTop - clientHeight * 0.5], [0, 1], easing);
  //const scale0 = useTransform(scrollY, [elementTop[0] - clientHeight, elementTop[0] - clientHeight / 2], [0, 1], easing);
  //const scale1 = useTransform(scrollY, [elementTop[1] - clientHeight, elementTop[1] - clientHeight / 2], [0, 1], easing);
  //const scale2 = useTransform(scrollY, [elementTop[2] - clientHeight, elementTop[2] - clientHeight / 2], [0, 1], easing);
  //console.log('cus reviews: ', elementTop, ref.current && ref.current.offsetTop);
  
  return (
    <div ref={ref} className="cs-customer-section section-gap-small" onLoad={setValues}>

      <div className="container">

        <div className="reviewImageWrapper">
          <div className="row d-flex flex-wrap">

            <div className="col">
              <div className="cs-customer-title"><h3>Customers can’t have enough of it!</h3></div>
              <motion.img style={{ x: mobileY, opacity: mobileOp }} src={CSReviewImage2} className="dark-shadow" title="Omnichannel Shopping Experience" alt="omnichannel retailing" />
            </div>
            <div className="col" >
              <div className="cs-customer-title"><h3>Customers can’t have enough of it!</h3></div>
              <motion.img style={{ scale: scale0 }} src={CSReviewIpadImage3} alt="iOS app user" title="iOS app user" />
              <motion.img /* ref={r => ref.current[1] = r}  style={{ scale: scale1 }} */ src={CSReviewIpadImage1} alt="Android app user" title="Android app user" />
              <motion.img /* ref={r => ref.current[2] = r}  style={{ scale: scale2 }} */ src={CSReviewIpadImage2} alt="User experience for HT" title="User experience for HT" />
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}